export default ([
  {
    label   : 'Admission AOG',
    itemKey : ['admissionAOGType', 'admissionAOG','admissionWeeks', 'admissionDays'],
    legend  : ['type', 'range', 'weeks', 'days'],
    decoder : null
  },
  {
    label   : 'Pregnancy Type',
    itemKey : 'pregnancyType',
    decoder : 'decodePregnancyType'
  },
  {
    label   : 'Abortion Type',
    itemKey : 'abortionType',
    decoder : 'decodeAbortionType'
  },
  {
    label   : 'Ectopic Type',
    itemKey : 'ectopicType',
    decoder : 'decodeEctopicType'
  },
  {
    label   : 'Molar Type',
    itemKey : 'molarType',
    decoder : 'decodeMolarType'
  }
])
